// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__26WHP","textArea":"TextArea_textArea__1qLpL","label":"TextArea_label__1zevk","error":"TextArea_error__9OQPr"};